module.exports = __webpack_public_path__ + "static/media/vacuum-cleaner.b634c831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vacuum-cleaner.png
// module id = 1064
// module chunks = 0